import React from 'react'
import styled from '@emotion/styled'

const Main = styled.main`
  margin-top: 70px;
  padding: 1rem;
  line-height: 1.5rem;

  @media (min-width: 64em) {
    margin: 0 auto;
    max-width: 960px;
    padding-top: 90px;
  }
`

const Title = styled.h2`
  padding-top: 90px;
  margin-top: -80px;
  font-weight: 200;
  color: #275236;
`

const Section = styled.section`
  position: relative;

  a {
    text-decoration: none;
    color: initial;
  }

  ul {
    li {
      margin: 0.5rem 0;
    }
  }
`

export default () => (
  <div>
    <Main>
      <Section>
        <Title>Jelentősebb munkáink</Title>
        <ul>
          <li>
            V. ker.Budapest, Hercegprímás u.7. Szent István Bazilika. Tető javítás, karbantartása, alapvezeték cserék,
            Lovagterem felújítása, Nagykupola javítás, kőpárkány veszélytelenítés, stb…
          </li>
          <li>
            V. ker. Budapest, Váci u.62-64.Kormányhivatal. Tetőfelújítás, bádogos munkák, kőrestaurálás. Homlokzati dísz
            veszélytelenítése, alpintechnikával. Kormányhivatalok eseti megbízásos tető javítása, felújítása.
          </li>
          <li>II. ker. Budapest, Than Károly utca (KSH) Belső homlokzat felújítása.</li>
          <li>VI. ker. Bolgár Nagykövetség műemlék homlokzati munkái. I-IV ütem. Utólagos falszigetelés. </li>
          <li>
            XI. ker. Budapest, BME MT épület, műemléki attikafal bontása, építése, díszes falazással, kő fedkővel.
          </li>
          <li>V. ker. Budapest, Báthory u.5. Társasház. Műemléki díszes kémény, palatető javítás, bádog javítás.</li>
          <li>1054. Budapest, Báthory u.5 1525 m2 palatető felújítás. Veszélyes hulladék elszállítása. </li>
          <li>
            XIII. ker. Budapest, Tar. u. 6-8. Tető, bádog, kémény, homlokzat külső, belső felújítás, utólagos
            falszigetelés, lépcsőházak festése. Lakásösszevonások a teljes építőmesteri munkákkal.
          </li>
          <li>
            IX. Börzsöny u.13 Rendőrőrs felújítása. Külső homlokzat felújítás, belső bontás, válaszfalépítés, betonozás,
            vakolás, belső festési munkák, burkolás, takarítás.
          </li>
          <li>
            VII. ker. Damjanich u.13 műemléki kocsiszín, téglahomlokzat felújítási munkái, belső felújítás. Vakolás,
            külső-belső festés, gipszkartonozás, revíziós ajtók elhelyezése, hágcsólétra, villanyszerelés, bádogozás,
            gépészet.
          </li>
          <li>V. ker. Budapest, Falk Miksa u.23. Társasház. Belső udvar betonozása, burkolása.</li>
          <li>V. ker. Budapest, Hercegprímás u.7. Szent István Bazilika. Tető karbantartása.</li>
          <li>XX.ker. Önkormányzat, Polgármesteri Hivatal Intézményeiben tető karbantartási munkák.</li>
          <li>Külső-Pesti Tankerület. Tető karbantartási munkák.</li>
        </ul>
      </Section>
    </Main>
  </div>
)
